// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./MathCourseDetailImages/backgroundTestimonal.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./MathCourseDetailImages/testimonal1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./MathCourseDetailImages/testimonal2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./MathCourseDetailImages/Abacus2.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Testimonal_Heading{
	color: #333;
	text-align: center;
	text-transform: uppercase;
	font-family: "Roboto", sans-serif;
	font-weight: bold;
	position: relative;
	margin: 30px 0 60px;
}
h2::after {
	/* content: "";
	width: 100px;
	position: absolute;
	margin: 0 auto;
	height: 3px;
	background: #111211;
	left: 0;
	right: 0;
	bottom: -10px; */
}
.col-center {
	margin: 0 auto;
	float: none !important;
}
.carousel {
	padding: 0 70px;
}
.carousel .carousel-item {
	color: #999;
	font-size: 14px;
	text-align: center;
	overflow: hidden;
	min-height: 290px;
}
.background{ 
    width: 100%;
    height:500px; 
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover; 
    position: relative;
}
.carousel .carousel-item .img-box1 {
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_1___});
 
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}

.carousel .carousel-item .img-box2 {
    background:  url(${___CSS_LOADER_URL_REPLACEMENT_2___});
 
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
	width: 135px;
	height: 135px;
	margin: 0 auto;
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 50%;
}
.carousel .img-box img {

	width: 100%;
	height: 100%;
	display: block;
	border-radius: 50%;
}
.carousel .testimonial {
	padding: 30px 0 10px;
}
.carousel .overview {	
	font-style: italic;
}
.carousel .overview b {
	text-transform: uppercase;
	color: #7AA641;
}
.carousel-control-prev, .carousel-control-next {
	width: 40px;
	height: 40px;
	margin-top: -20px;
	top: 50%;
	background: none;
}
.carousel-control-prev i, .carousel-control-next i {
	font-size: 68px;
	line-height: 42px;
	position: absolute;
	display: inline-block;
	color: rgba(0, 0, 0, 0.8);
	text-shadow: 0 3px 3px #e6e6e6, 0 0 0 #000;
}
.carousel-indicators {
	bottom: -40px;
}
.carousel-indicators li, .carousel-indicators li.active {
	width: 12px;
	height: 12px;
	margin: 1px 3px;
	border-radius: 50%;
	border: none;
}
.carousel-indicators li {	
	background: #999;
	border-color: transparent;
	box-shadow: inset 0 2px 1px rgba(0,0,0,0.2);
}
.carousel-indicators li.active {	
	background: #555;		
	box-shadow: inset 0 2px 1px rgba(0,0,0,0.2);
}
.image{

    background:  url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  
    width: 340px;
    height: 320px; 
    margin: auto;
    background-size: cover;
    background-position: center;
    position: relative;
    background-repeat:no-repeat ;
    
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/MathPortal/Slider.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,kBAAkB;CAClB,yBAAyB;CACzB,iCAAiC;CACjC,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC;;;;;;;;iBAQgB;AACjB;AACA;CACC,cAAc;CACd,sBAAsB;AACvB;AACA;CACC,eAAe;AAChB;AACA;CACC,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,oDAAqE;IACrE,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,oDAA4D;;IAE5D,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;IACI,oDAA4D;;IAE5D,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;CAC/B,YAAY;CACZ,aAAa;CACb,cAAc;CACd,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;AACA;;CAEC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,QAAQ;CACR,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,qBAAqB;CACrB,yBAAyB;CACzB,0CAA0C;AAC3C;AACA;CACC,aAAa;AACd;AACA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,2CAA2C;AAC5C;AACA;CACC,gBAAgB;CAChB,2CAA2C;AAC5C;AACA;;IAEI,oDAAwD;;IAExD,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,4BAA4B;;AAEhC","sourcesContent":[".Testimonal_Heading{\n\tcolor: #333;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\tfont-family: \"Roboto\", sans-serif;\n\tfont-weight: bold;\n\tposition: relative;\n\tmargin: 30px 0 60px;\n}\nh2::after {\n\t/* content: \"\";\n\twidth: 100px;\n\tposition: absolute;\n\tmargin: 0 auto;\n\theight: 3px;\n\tbackground: #111211;\n\tleft: 0;\n\tright: 0;\n\tbottom: -10px; */\n}\n.col-center {\n\tmargin: 0 auto;\n\tfloat: none !important;\n}\n.carousel {\n\tpadding: 0 70px;\n}\n.carousel .carousel-item {\n\tcolor: #999;\n\tfont-size: 14px;\n\ttext-align: center;\n\toverflow: hidden;\n\tmin-height: 290px;\n}\n.background{ \n    width: 100%;\n    height:500px; \n    background:  url('./MathCourseDetailImages/backgroundTestimonal.png');\n    background-size: cover; \n    position: relative;\n}\n.carousel .carousel-item .img-box1 {\n    background:  url('./MathCourseDetailImages/testimonal1.png');\n \n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n\n.carousel .carousel-item .img-box2 {\n    background:  url('./MathCourseDetailImages/testimonal2.png');\n \n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n\twidth: 135px;\n\theight: 135px;\n\tmargin: 0 auto;\n\tpadding: 5px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 50%;\n}\n.carousel .img-box img {\n\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n\tborder-radius: 50%;\n}\n.carousel .testimonial {\n\tpadding: 30px 0 10px;\n}\n.carousel .overview {\t\n\tfont-style: italic;\n}\n.carousel .overview b {\n\ttext-transform: uppercase;\n\tcolor: #7AA641;\n}\n.carousel-control-prev, .carousel-control-next {\n\twidth: 40px;\n\theight: 40px;\n\tmargin-top: -20px;\n\ttop: 50%;\n\tbackground: none;\n}\n.carousel-control-prev i, .carousel-control-next i {\n\tfont-size: 68px;\n\tline-height: 42px;\n\tposition: absolute;\n\tdisplay: inline-block;\n\tcolor: rgba(0, 0, 0, 0.8);\n\ttext-shadow: 0 3px 3px #e6e6e6, 0 0 0 #000;\n}\n.carousel-indicators {\n\tbottom: -40px;\n}\n.carousel-indicators li, .carousel-indicators li.active {\n\twidth: 12px;\n\theight: 12px;\n\tmargin: 1px 3px;\n\tborder-radius: 50%;\n\tborder: none;\n}\n.carousel-indicators li {\t\n\tbackground: #999;\n\tborder-color: transparent;\n\tbox-shadow: inset 0 2px 1px rgba(0,0,0,0.2);\n}\n.carousel-indicators li.active {\t\n\tbackground: #555;\t\t\n\tbox-shadow: inset 0 2px 1px rgba(0,0,0,0.2);\n}\n.image{\n\n    background:  url('./MathCourseDetailImages/Abacus2.jpg');\n  \n    width: 340px;\n    height: 320px; \n    margin: auto;\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    background-repeat:no-repeat ;\n    \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
